import React from 'react';
import "./schedule.css";
import abstracts from "../Assests/Abstracts.pdf";

function Schedule() {
  return (
    <div className="schedule-container">
      <h2>Colloquium Agenda</h2>

      <div className="day">
        <h3>Day 1 (20th September 2024, <a href="https://maps.app.goo.gl/Xt4HnfZWvHvjBofH9">Seminar Hall</a>) [<a href={abstracts} target="_blank">Abstract booklet</a>] </h3>
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Speaker</th>
              <th>Affiliation</th>
              <th>Topic</th>
            </tr>
          </thead>
          <tbody>
            <tr className="session-row">
              <td data-label="Time"></td>
              <td data-label="Session" colSpan="3" style={{fontWeight:"bold", textTransform:"none"}}>Session 1: Welcome and Introduction</td>
            </tr>
            <tr>
              <td  data-label="Time">9:30 AM</td>
              <td data-label="Details" colSpan="3">Director IIT Delhi, Deputy Director Strategy & Planning, Chair Organising Committee</td>
            </tr>
            <tr className="session-row">
              <td data-label="Time"></td>
              <td  style={{fontWeight:"bold", textTransform:"none"}} data-label="Session" colSpan="3">Session 2: Neuroscience and Neurobiology</td>
            </tr>
            <tr>
              <td data-label="Time">10:00 AM</td>
              <td data-label="Speaker">Venkatesh Murthy</td>
              <td data-label="Affiliation">Harvard</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Animal learning and machine learning</td>
            </tr>
            <tr>
              <td data-label="Time">10:30 AM</td>
              <td data-label="Speaker">Upinder Bhalla</td>
              <td data-label="Affiliation">NCBS</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Multiscale modeling for data-driven neuroscience</td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>11:00 AM</td>
              <td data-label="Details" style={{background:"#e74c3c",color:"white"}} colSpan="3">Coffee/Tea Break</td>
            </tr>
            <tr>
              <td data-label="Time">11:30 AM</td>
              <td data-label="Speaker">Aditya Murthy</td>
              <td data-label="Affiliation">IISc</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Neural correlates of intention in muscles</td>
            </tr>
            <tr className="session-row">
              <td data-label="Time"></td>
              <td data-label="Session" colSpan="3" style={{fontWeight:"bold", textTransform:"none"}}>Session 3: Cognition and Behaviour</td>
            </tr>
            <tr>
              <td data-label="Time">12:00 PM</td>
              <td data-label="Speaker">Pawan Sinha</td>
              <td data-label="Affiliation">MIT</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Extracting Meaning from a Blooming, Buzzing Confusion: The Fascinating Challenge of Understanding Brain Development</td>
            </tr>
            <tr>
              <td data-label="Time">12:30 PM</td>
              <td data-label="Speaker">Narayanan Srinivasan</td>
              <td data-label="Affiliation">IIT Kanpur</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Consciousness and Time</td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>1:00 PM</td>
              <td data-label="Details" colSpan="3" style={{background:"#e74c3c",color:"white"}}>Lunch</td>
            </tr>
            <tr>
              <td data-label="Time">2:30 PM</td>
              <td data-label="Speaker">Brian Dillon</td>
              <td data-label="Affiliation" style={{textTransform:"none"}}>University of Massachusetts Amherst</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Evaluating expectation-based language comprehension with the Syntactic Ambiguity Processing benchmark</td>
            </tr>
            <tr className="session-row">
              <td data-label="Time"></td>
              <td data-label="Session" colSpan="3" style={{fontWeight:"bold"}}>Session 4: Minds & Machines (AI, Robotics, Design)</td>
            </tr>
            <tr>
              <td data-label="Time">3:00 PM</td>
              <td data-label="Speaker">Harish Karnick</td>
              <td data-label="Affiliation">IIT Kanpur</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Cognitive implications of recent advances in generative AI: some thoughts</td>
            </tr>
            
            <tr>
              <td data-label="Time">3:30 PM</td>
              <td data-label="Speaker">John Gero</td>
              <td data-label="Affiliation" style={{textTransform:"none"}}>University of North Carolina at Charlotte</td>
              <td data-label="Topic" style={{textTransform:"none"}}>Neurocognition Needs Ecologically Valid Tasks: The Neurocognition of Design</td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>4:00 PM</td>
              <td data-label="Details" style={{background:"#e74c3c",color:"white"}} colSpan="3">Tea/Coffee</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="day">
        <h3>Day 2 (21st September 2024, <a href="https://maps.app.goo.gl/gZ2amDqG5DcFVPZa6">R&I Park Board Room</a>)</h3>
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Session</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr className="session-row">
              <td data-label="Time" style={{fontWeight:"bold"}}>9:00 AM &ndash; 11:00 AM</td>
              <td data-label="Session" style={{textTransform:"none", fontWeight:"bold"}}>Session 5: Neuroscience and Neurobiology</td>
              <td data-label="Details">
                IIT Delhi group presentation<br />
                Discussants: John Gero, Brian Dillon, Venkatesh Murthy<br />
              </td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>11:00 AM</td>
              <td data-label="Details" style={{background:"#e74c3c",color:"white"}} colSpan="2">Coffee/Tea Break</td>
            </tr>
            <tr className="session-row">
              <td data-label="Time" style={{fontWeight:"bold"}}>11:30 AM &ndash; 1:30 PM</td>
              <td data-label="Session" style={{textTransform:"none", fontWeight:"bold"}}>Session 6: Cognition and Behaviour</td>
              <td data-label="Details">
                IIT Delhi group presentation<br />
                Discussants: Upinder Bhalla, Narayanan Srinivasan<br />
              </td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>1:30 PM</td>
              <td data-label="Details" style={{background:"#e74c3c",color:"white"}} colSpan="2">Lunch</td>
            </tr>
            <tr className="session-row">
              <td data-label="Time" style={{fontWeight:"bold"}}>2:30 PM &ndash; 4:30 PM</td>
              <td data-label="Session" style={{fontWeight:"bold"}}>Session 7: Minds & Machines (AI, Robotics, Design)</td>
              <td data-label="Details">
                IIT Delhi group presentation<br />
                Discussants: Pawan Sinha, Aditya Murthy, Harish Karnick<br />
              </td>
            </tr>
            <tr className="break-row">
              <td data-label="Time" style={{background:"#e74c3c",color:"white"}}>4:30 PM</td>
              <td data-label="Details" style={{background:"#e74c3c",color:"white"}} colSpan="3">Tea/Coffee</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Schedule;